import { render } from "./FriendAssignView.vue?vue&type=template&id=e5f9cc30"
import script from "./FriendAssignView.vue?vue&type=script&lang=js"
export * from "./FriendAssignView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__